const waveCartUtils = (function () {
  function post (url, body) {
    return fetch(url, {
      method: "POST",
      body: JSON.stringify(body),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  function get (url) {
    return fetch(url, {
      credentials: "same-origin",
      method: "GET",
    });
  }

  function getCart () {
    var url = "".concat(theme.routes.cartJs, `?t=${Date.now()}`);
    return get(url).then((response) => response.json());
  }

  function getPreorderItemsCart () {
    var url = "".concat('/cart', `?view=preorder-items-cart-json&t=${Date.now()}`);
    return get(url).then((response) => response.json());
  }

  function changeItem ({
    key,
    quantity,
    properties,
  }) {
    return post(theme.routes.cartJsChange, {
      id: key,
      quantity: quantity,
      properties: properties,
    });
  }

  function addItems (
    items,
    sections,
    sections_url,
  ) {
    return post(theme.routes.cartJsAdd, {
      items,
      sections,
      sections_url,
    });
  }

  async function clearAddOn () {
    const cart = await getCart();
    const unissuedAddOns = cart.items.filter((item) => {
      return (
        item.properties["__add_on"] && !item.properties["__add_on"]["issued"]
      );
    });

    const param = { updates: {} };
    for (const item of unissuedAddOns) {
      param.updates[item.key] = 0;
    }
    if (unissuedAddOns.length > 0) {
      await post(theme.routes.cartJsUpdate, param);
    }
    return unissuedAddOns.length > 0;
  }

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
  }

  return {
    changeItem: changeItem,
    getCart: getCart,
    addItems: addItems,
    clearAddOn: clearAddOn,
    getRandomInt: getRandomInt,
    getPreorderItemsCart: getPreorderItemsCart
  };
})();

document.addEventListener('wv_addon_flow_ended', () => {
  document.dispatchEvent(new CustomEvent('theme:cart:reload', {
    bubbles: true,
    detail: {
      force: true,
    }
  }));
});

document.addEventListener('wv_addon_removing_from_cart', (e) => {
  document.dispatchEvent(new CustomEvent('theme:cart:lockforvariant', {
    bubbles: true,
    detail: {
      variant: {
        id: e.detail.variant.id,
      }
    }
  }));
});

document.addEventListener('wv_addon_added_to_cart', (e) => {
  document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
    bubbles: true,
    detail: {
      variant: {
        id: e.detail.variant.id,
      }
    }
  }));
});
